module.exports = __webpack_public_path__ + "img/Nodataimg.1902afdd.png";